import { Button, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { useAuthContext } from 'src/auth/useAuthContext.js';
import { useLocales } from 'src/locales';
import { UserRequest } from 'src/requests/user.js';
import {
  GlobalAlertContainer,
  GlobalAlertDivider,
} from '../GlobalAlert/GlobalAlert';
import { colorsByExpirationTime } from '../GlobalAlert/utils';

export const VerifyAccountAlert = () => {
  const theme = useTheme();
  const { translate } = useLocales();

  const { user } = useAuthContext();

  const colors = useMemo(
    () => colorsByExpirationTime(theme, user?.createdAt || ''),
    [user, theme],
  );

  const handleResendCode = async () => {
    await UserRequest.resendCode();
    toast.success(translate('verify_account_alert.verification_email_resend'));
  };

  return (
    <GlobalAlertContainer colors={colors}>
      <Typography variant="subtitle2">
        {translate('verify_account_alert.account_not_validated')}
      </Typography>

      <GlobalAlertDivider colors={colors} />

      <Typography variant="body2">
        {translate('verify_account_alert.validation_code_message')}
      </Typography>

      <GlobalAlertDivider colors={colors} />

      <Button
        size="small"
        variant="soft"
        color="inherit"
        sx={{ mx: 2, color: colors.color }}
        onClick={handleResendCode}
      >
        {translate('verify_account_alert.verify_email')}
      </Button>
    </GlobalAlertContainer>
  );
};
